<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new transporter truck</small>
      </legend>
      <div>
        <form @submit.prevent="newTruck()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="transporter_id" :value="Transporter.id" />
              <div class="form-group">
                <label>Truck no</label>
                <input type="text" class="form-control truck_no" placeholder="truck number plate" />
              </div>
              <div class="form-group">
                <label>Truck chassis no</label>
                <input type="text" class="form-control truck_chassis" placeholder="" />
              </div>
              <div class="form-group">
                <label>Engine no</label>
                <input type="text" class="form-control truck_engine_no" placeholder="driver id number" />
              </div>
              <div class="form-group">
                <label>Truck Logbook name</label>
                <input type="text" class="form-control logbook_name" placeholder="driving licence number" />
              </div>
              
              <div class="form-group">
                <label>Truck price</label>
                <input type="number" min="0" step="0.01" class="form-control truck_price" />
              </div>
              <div class="form-group">
                <label>Clearing cost</label>
                <input type="number" min="0" step="0.01" class="form-control clearing_cost" />
              </div>
              <div class="form-group">
                <label>Repair/M Cost</label>
                <input type="number" min="0" step="0.01" class="form-control rm_cost" />
              </div>


            </div>
            <div class="col-md-6">
             
              <div class="form-group">
                <label>Trailer no</label>
                <input type="text" class="form-control trailer_no" placeholder="trailer number" />
              </div>
              <div class="form-group">
                <label>Trailer chassis no</label>
                <input type="text" class="form-control trailer_chassis" placeholder="" />
              </div>
              <div class="form-group">
                <label>Trailer Logbook name</label>
                <input type="text" class="form-control logbook_name_trailer" placeholder="driving licence number" />
              </div>
              <div class="form-group">
                <label>Trailer price</label>
                <input type="number" min="0" step="0.01" class="form-control trailer_price" />
              </div>
              <div class="form-group">
                <label>Total Cost</label>
                <input type="number" min="0" step="0.01" class="form-control total_cost" />
              </div>
              <div class="form-group">
                <label>Remark</label>
                <input type="text" class="form-control remark" placeholder="" />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingTruck btn-rounded">
            <i class="fa fa-truck"></i>Add Truck
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingTruckLoader btn-rounded">
            <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router";
export default {
  created() {
    if (this.$store.getters.Transporter.length === 0) {
      router.push("/managetransporters");
    }
  },
  computed: {
    ...mapGetters(["Transporter"]),
  },
  methods: {
    ...mapActions(["newTruck"]),
  },
};
</script>
<style scoped>
.creatingTruckLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trucks/trucks.vue